import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService, OperationItem } from '../../../services/logistic.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
    selector: 'tt-shop-floor-select-oh',
    templateUrl: './shop-floor-select-oh.component.html',
    styleUrls: ['./shop-floor-select-oh.component.css'],
})
export class ShopFloorSelectOhComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListFactories: FactoryItem[] = [];

    public selectListOperations: OperationItem[] = [];

    public selectListEquipments: Item[] = [];

    public grid?: GridOptions;

    constructor(
        private datatask: DataTaskService,
        private logistic: LogisticService,
    ) {}

    private async loadSetting() {
        this.setting = (await this.datatask.Post(3811))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadFactories() {
        if (!this.setting) return;

        this.selectListFactories = await this.datatask.Post(2024, { businessco_no: this.setting.businessco_no });
    }

    private async loadOperations() {
        if (!this.setting) return;

        this.selectListOperations = await this.logistic.getOperations({
            direct: '1',
            factory_id: this.setting.factory_id,
        });
    }

    private async loadEquipments() {
        if (!this.setting) return;

        this.selectListEquipments = await this.datatask.Post(2039, {
            workgrp_keyno: '0',
            factory_id: this.setting.factory_id,
            operation_id: this.setting.operation_id,
        });
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_shopfloorselectoh_grid')
                .setLoadDataFunction({ method: 3812, parameters: () => this.setting })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no':
                Promise.all([this.loadFactories()]).then(() => {
                    this.loadGrid();
                    Promise.resolve();
                });
                break;
            case 'factory_id':
                Promise.all([this.loadOperations(), this.loadEquipments()]).then(() => {
                    this.loadGrid();
                    Promise.resolve();
                });
                break;
            case 'operation_id':
                Promise.all([this.loadEquipments()]).then(() => {
                    this.loadGrid();
                    Promise.resolve();
                });
                break;
            case 'equipment_id':
                this.loadGrid();
                break;
            case 'group_by_component':
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();

        return Promise.all([this.loadFactories(), this.loadOperations(), this.loadEquipments()]).then(() => {
            this.loadGrid();
            Promise.resolve();
        });
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no: string;
    factory_id: string;
    operation_id: string;
    equipment_id: string;
    date_fom: string;
    date_tom: string;
    dateselector_index: string;
    date_fomtom: string;
    labour_no: string;
    labour_name: string;
    show_setting: string;
    group_by_component: string;
}

interface FactoryItem {
    factory_id: string;
    factory_name: string;
    orderby: number;
}
